import { HoursMins } from "../../../SubjectData/BasicWords/Time.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";

export default function HoursMinsDeck() {
  return (
    <>
      <HeaderNav GoBack_to="/TimeNav" />
      <FlashcardInterface deckData={HoursMins} title="Hours + Minutes" />
    </>
  );
}
